<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M16.6666 10.4167V5.66667C16.6666 4.26654 16.6666 3.56647 16.3941 3.0317C16.1544 2.56129 15.772 2.17884 15.3016 1.93916C14.7668 1.66667 14.0667 1.66667 12.6666 1.66667H7.33325C5.93312 1.66667 5.23306 1.66667 4.69828 1.93916C4.22787 2.17884 3.84542 2.56129 3.60574 3.0317C3.33325 3.56647 3.33325 4.26654 3.33325 5.66667V14.3333C3.33325 15.7335 3.33325 16.4335 3.60574 16.9683C3.84542 17.4387 4.22787 17.8212 4.69828 18.0609C5.23306 18.3333 5.93308 18.3333 7.33313 18.3333H10.4166M11.6666 9.16667H6.66659M8.33325 12.5H6.66659M13.3333 5.83334H6.66659M12.4999 15.8333L14.9999 18.3333M14.9999 18.3333L17.4999 15.8333M14.9999 18.3333V13.3333"
      stroke="currentColor"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
